import React from 'react';

export default function ScannerHeader({ scannerMode, continuousMode, onClose }) {
  return (
    <div className="flex items-center justify-between p-4 border-b border-gray-200">
      <h2 className="text-xl font-bold text-gray-900">
        {scannerMode === 'camera' ? 'Scan Barcode' : 'Enter Barcode'}
        {continuousMode && (
          <span
            className="ml-2 inline-block text-xs font-semibold text-green-700 bg-green-100 border border-green-300 rounded-full px-2 py-0.5 align-middle"
            data-testid="continuous-mode-indicator"
          >
            Continuous mode ON
          </span>
        )}
      </h2>
      <button
        onClick={onClose}
        data-testid="scanner-close-button"
        className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
      >
        ×
      </button>
    </div>
  );
}
